export default "__VITE_ASSET__d78e1c21__"